import { useState } from 'react';
import { FaLayerGroup } from 'react-icons/fa';
import { IoCreate, IoFilterSharp } from 'react-icons/io5';
import { IoMdAdd } from 'react-icons/io';
import { SlArrowDown } from 'react-icons/sl';

import TaskContent from './TaskContent';
import BugContent from './BugContent';
import UserStoryContent from './UserStoryContent';
import SprintCreationForm from './SprintCreationForm';

const BacklogContent = ({ sectionId, sectionData, setAlldata, alldata }) => {
  const [showForm, setShowForm] = useState(false);
  const [showStories, setShowStories] = useState(true);
  const handleSprintCreation = () => {
    setShowForm(true);
  };

  return (
    <div className="relative rounded-lg">
      <div className="sticky left-0 top-0 z-50 mt-4 flex w-full items-center justify-between rounded-t-md border border-zinc-700 bg-zinc-800 px-4 py-1.5">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-bold text-gray-50">{sectionData.name}</h3>
          <p className="text-sm">{`(${sectionData.noOfissues} issues)`}</p>
        </div>
        <div className="flex items-center gap-4">
          <button className="inline-flex items-center justify-center gap-1 text-nowrap rounded-2xl border bg-[#1d1d1f] px-2 py-1 text-base font-semibold text-gray-50 transition duration-100 hover:text-white">
            <span>
              <IoMdAdd size={15} />
            </span>
            Create issue
          </button>
          <button className="inline-flex items-center justify-center gap-2 text-nowrap rounded-2xl border bg-[#1d1d1f] px-2 py-1 font-semibold text-gray-50 transition duration-100 hover:text-white">
            <IoFilterSharp size={15} />
            Filter
          </button>
          <button className="inline-flex items-center justify-center gap-2 text-nowrap rounded-2xl border bg-[#1d1d1f] px-2 py-1 font-semibold text-gray-50 transition duration-100 hover:text-white">
            <FaLayerGroup size={15} />
            Group
          </button>
          <button
            className="inline-flex items-center justify-center gap-2 text-nowrap rounded-2xl border bg-[#1d1d1f] px-2 py-1 font-semibold text-gray-50 transition duration-100 hover:text-white"
            onClick={handleSprintCreation}
          >
            <IoCreate size={15} />
            Create sprint
          </button>
          <button
            className={`${
              !showStories ? 'rotate-180' : 'rotate-0'
            } transition duration-150`}
            onClick={() => setShowStories((prev) => !prev)}
          >
            <SlArrowDown size={12} />
          </button>
        </div>
      </div>
      {showStories && (
        <div className="flex min-h-screen flex-col overflow-y-auto">
          {sectionData.issues.map((item, index) => {
            return item.fields?.issuetype?.name === 'Story' ? (
              <UserStoryContent
                key={item.id}
                storyId={item.id}
                data={sectionData}
                sectionId={sectionId}
              />
            ) : item.fields?.issuetype?.name === 'Task' ? (
              <TaskContent key={item.id} item={item} />
            ) : (
              <BugContent key={item.id} item={item} />
            );
          })}
        </div>
      )}
      {showForm && (
        // eslint-disable-next-line
        <div
          className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50"
          onClick={() => setShowForm(false)}
        >
          <SprintCreationForm
            allData={alldata}
            setallData={setAlldata}
            setShowForm={setShowForm}
          />
        </div>
      )}
      {showStories && (
        <div className="mt-4 flex w-full items-center justify-center px-2">
          <button className=" flex h-10 w-full items-center justify-center gap-3 rounded-lg bg-zinc-700 px-8 text-center text-lg font-semibold hover:bg-[#343438]">
            <span className="font-bold">
              <IoMdAdd />
            </span>
            <span>Create issue</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default BacklogContent;
